export const environment = {
    production: true,
    apiEndPoint:'https://admin-api.blockoville.com/apiroute/',
    recaptchsitekey: '6LfH_J4tAAAAAJHHR6FJ-EzlwiEqYGwApacRWBUT',
    imageapiendpoint:'https://admin-api.blockoville.com/apiroute/uploads/',
    S3_BUCKET_URL: 'https://blockoville-otc.s3.eu-central-1.amazonaws.com/',
    adminConfigurlNew: "",
    pusher: {
      channel: "blockoville",
      channelprice: "blockovillePrice",
      key: "c687297ff4dbb7d677ae",
      cluster: "ap2",
    },
    TOKEN_SECRET: "adm76HFJnasFFFgavawa321",
    name:'test'
  };
  


// WEBPACK FOOTER //
// ./src/environments/environment.ts